import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_b9p9hsm8y2: FaireCollectionEntity = {
  token: "pbc_b9p9hsm8y2",
  type: "collection",
  name: "Autumn",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d87d4925eb22466d9647da6aa8d49828892edea2e5af114688d363241d44e980.jpeg",
  itemCount: 56,
  brandToken: "b_mmdanrh9jf",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:09:21.502Z",
    importedBy: "entity-db-import-collections",
  },
};
